import React from 'react';
import './App.css';
import Dialog from './components/dialogs';
import Auth from './components/auth';
import { Static } from './components/statistic/Static';
import Interaction from './components/interaction';
import HUD from './components/hud';
import { Inventory } from './components/inventory';
import Phone from './components/phone';
import Captcha from './components/captcha';
import BattlePass from './components/bp';

type AppType = {
  showDialog:boolean;
}
class App extends React.Component<any, AppType>  {
  phoneVisible = false;
  inventoryVisible = false;
  phoneToggleLastAt = 0;

  constructor(props:any) {
    super(props);
    this.state = {
      showDialog:true
    };
  }  

  parsePayload = (payload: any) => {
    const raw = Array.isArray(payload) ? payload[0] : payload;
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw);
      } catch (error) {
        return null;
      }
    }
    if (raw && typeof raw === 'object') return raw;
    return null;
  }

  handlePhoneEvent = (...args: any[]) => {
    const payload = this.parsePayload(args);
    if (!payload) return;
    if (typeof payload.show !== 'boolean') return;
    this.phoneVisible = payload.show;
  }

  handleInventoryEvent = (...args: any[]) => {
    const payload = this.parsePayload(args);
    if (!payload || typeof payload.show !== 'boolean') return;
    this.inventoryVisible = payload.show;
  }

  isInventoryMounted = () => Boolean(document.querySelector('.inventory-wrapper'))
  isIncomingPromptVisible = () => Boolean(document.querySelector('.cef-phone-call-tip.incoming'))
  isPhoneCallScreenVisible = () => Boolean(document.querySelector('.cef-phone-call'))

  syncHotkeyVisibilityState = () => {
    this.inventoryVisible = this.isInventoryMounted();
  }

  isBlockedByOtherCefWindow = () => {
    return Boolean(
      document.querySelector('.dialog_main') ||
      document.querySelector('.auth_main') ||
      document.querySelector('.Static') ||
      document.querySelector('.interact_main') ||
      document.querySelector('.interact_info') ||
      document.querySelector('.cef-captcha') ||
      document.querySelector('.bp-root')
    );
  }

  handleGlobalHotkeys = (event: KeyboardEvent) => {
    if (event.repeat) return;
    if (event.ctrlKey || event.altKey || event.metaKey) return;

    const target = event.target as HTMLElement | null;
    if (target) {
      const tagName = target.tagName?.toLowerCase();
      if (
        target.isContentEditable ||
        tagName === 'input' ||
        tagName === 'textarea' ||
        tagName === 'select'
      ) {
        return;
      }
    }

    if (event.keyCode !== 80 && event.keyCode !== 73 && event.keyCode !== 76 && event.keyCode !== 72) return;
    this.syncHotkeyVisibilityState();
    if (this.isBlockedByOtherCefWindow()) return;

    if (event.keyCode === 80) {
      if (this.phoneVisible && this.isIncomingPromptVisible()) {
        event.preventDefault();
        window.cef.emit('cef:phoneAction', 'answer');
        return;
      }
      if (this.inventoryVisible) return;
      const now = Date.now();
      if (now - this.phoneToggleLastAt < 220) return;
      this.phoneToggleLastAt = now;
      event.preventDefault();
      const isOpen = this.phoneVisible;
      const action = isOpen ? 'close' : 'open';
      window.dispatchEvent(new CustomEvent('ui:phoneToggleIntent', { detail: action }));
      return;
    }

    if (event.keyCode === 73) {
      if (this.phoneVisible) return;
      event.preventDefault();
      if (this.inventoryVisible) {
        window.cef.emit('cef:inventoryAction', 'close', 0, 0);
      } else {
        window.cef.emit('cef:inventoryAction', 'page', 0, 0);
      }
      return;
    }

    if (event.keyCode === 76) {
      if (this.phoneVisible || this.inventoryVisible) return;
      event.preventDefault();
      window.cef.emit('cef:hotkeyAction', 'lock');
      return;
    }

    if (event.keyCode === 72) {
      if (!this.isPhoneCallScreenVisible()) return;
      event.preventDefault();
      window.cef.emit('cef:phoneAction', 'hang');
    }
  }

  // handleKeyDown = (e:any) => {
  //   if( e.keyCode == 32 ) { this.setState( {showDialog: !this.state.showDialog} ) ; console.log("show"); }
  // }
  componentDidMount = () => {
    window.cef.set_focus( false );
    window.cef.on('cef:phone', this.handlePhoneEvent);
    window.cef.on('cef:inventory', this.handleInventoryEvent);
    document.addEventListener('keydown', this.handleGlobalHotkeys);
  //   document.addEventListener('keyup', this.handleKeyDown);
   }
  componentWillUnmount = () => {
    window.cef.off('cef:phone', this.handlePhoneEvent);
    window.cef.off('cef:inventory', this.handleInventoryEvent);
    document.removeEventListener('keydown', this.handleGlobalHotkeys);
  }
  render() {
      return (
      <div className="App">
        {this.state.showDialog ? <Dialog/> : null }
        <Auth/>
        <Static/>
        <Interaction/>
        <HUD/>
        <Captcha />
        <Inventory />
        <Phone />
        <BattlePass />
      </div>
    );
  }
}

export default App;
